<bs-digital-place-button />
